import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ProfileBookingsDesktopParent = loadable(() => import("./ProfileBookingsDesktopParent"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ProfileBookingsDesktopParent {...props} />
  </ErrorBoundary>
);
